import axios from "@/lib/axios";
import { useMutation } from "@tanstack/vue-query";
import { ToastInterface, useToast } from "vue-toastification";
import { Role } from "./useRoles";

type CreateRole = Omit<Role, "id" | "usersCount" | "title">;

const createRoleCompany = async (role: CreateRole, toast: ToastInterface) => {
  try {
    const data = await axios.post<CreateRole>(
      `/api/companies/${role.companyId}/roles`,
      role,
    );
    toast.success("Rol creado correctamente");
  } catch (error: any) {
    toast.error(error.response.data.message);
  }
};

const useRoleCompany = () => {
  const toast = useToast();

  const createRoleCompanyMutation = useMutation((role: CreateRole) =>
    createRoleCompany(role, toast),
  );

  return {
    createRoleCompanyMutation,
    createRoleCompanyMutationAsync: createRoleCompanyMutation.mutateAsync,
    createROleCompanyLoading: createRoleCompanyMutation.isLoading,
  };
};

export default useRoleCompany;
